<script setup>
import outlook_calendar from "@/assets/images/outlook_calendar.png";
import ical_calendar from "@/assets/images/ical_calendar.png";
import yahoo_calendar from "@/assets/images/yahoo_calendar.png";
import google_calendar from "@/assets/images/google_calendar.png";
</script>
<script>
import LazyImage from "@/components/atoms/lazy-image";

const MS_IN_MINUTES = 60 * 1000;

export default {
  name: "OrderToCalendar",
  components: {
    LazyImage
  },
  props: {
    title: {
      type: String,
      required: true
    },
    start: {
      type: Date,
      required: true
    },
    duration: {
      type: Number,
      required: true
    },
    end: {
      type: Date,
      required: true
    },
    address: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  computed: {
    endTimeFormated() {
      if (this.end) {
        return this.formatTime(this.end);
      }
      return this.formatTime(
        new Date(this.start.getTime() + this.duration * MS_IN_MINUTES)
      );
    },
    googleLink() {
      const startTime = this.formatTime(this.start);

      return encodeURI(
        [
          "https://www.google.com/calendar/render",
          "?action=TEMPLATE",
          "&text=" + (this.title || ""),
          "&dates=" + (startTime || ""),
          "/" + (this.endTimeFormated || ""),
          "&details=" + (this.description || ""),
          "&location=" + (this.address || ""),
          "&sprop=&sprop=name:"
        ].join("")
      );
    },
    yahooLink() {
      const eventDuration = this.end
        ? (this.end.getTime() - this.start.getTime()) / MS_IN_MINUTES
        : this.duration;

      // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
      const yahooHourDuration =
        eventDuration < 600
          ? "0" + Math.floor(eventDuration / 60)
          : Math.floor(eventDuration / 60) + "";

      const yahooMinuteDuration =
        eventDuration % 60 < 10
          ? "0" + (eventDuration % 60)
          : (eventDuration % 60) + "";

      const yahooEventDuration = yahooHourDuration + yahooMinuteDuration;

      // Remove timezone from event time
      const st = this.formatTime(this.start);

      return encodeURI(
        [
          "http://calendar.yahoo.com/?v=60&view=d&type=20",
          "&title=" + (this.title || ""),
          "&st=" + st,
          "&dur=" + (yahooEventDuration || ""),
          "&desc=" + (this.description || ""),
          "&in_loc=" + (this.address || "")
        ].join("")
      );
    },
    icsLink() {
      const startTime = this.formatTime(this.start);

      return encodeURI(
        "data:text/calendar;charset=utf8," +
          [
            "BEGIN:VCALENDAR",
            "VERSION:2.0",
            "BEGIN:VEVENT",
            "DTSTART:" + (startTime || ""),
            "DTEND:" + (this.endTimeFormated || ""),
            "SUMMARY:" + (this.title || ""),
            "DESCRIPTION:" + (this.description || ""),
            "LOCATION:" + (this.address || ""),
            "END:VEVENT",
            "END:VCALENDAR"
          ].join("\n")
      );
    }
  },
  methods: {
    formatTime(date) {
      if (date) {
        return date.toISOString().replace(/-|:|\.\d+/g, "");
      }
      return null;
    }
  }
};
</script>

<template>
  <div ref="calendar">
    <h2 class="u-color-primary">
      Choisissez votre type de calendrier :
    </h2>
    <div class="u-flex u-flex-wrap u-mt-sm">
      <div class="u-ml-sm u-mr-sm u-flex-item-auto">
        <a
          target="_blank"
          class="u-flex u-flex-column u-flex-align-center u-text-center u-mb-sm"
          :href="googleLink"
        >
          <LazyImage
            :src="google_calendar"
            height="64"
            width="64"
            class="u-mt-md u-mb-sm"
          />
          Calendrier Google
        </a>
      </div>
      <div class="u-ml-sm u-mr-sm u-flex-item-auto">
        <a
          target="_blank"
          class="u-flex u-flex-column u-flex-align-center u-text-center u-mb-sm"
          :href="yahooLink"
        >
          <LazyImage
            :src="yahoo_calendar"
            height="64"
            width="64"
            class="u-mt-md u-mb-sm"
          />
          Calendrier Yahoo
        </a>
      </div>
      <div class="u-ml-sm u-mr-sm u-flex-item-auto">
        <a
          class="u-flex u-flex-column u-flex-align-center u-text-center u-mb-sm"
          :href="icsLink"
        >
          <LazyImage
            :src="ical_calendar"
            height="64"
            width="64"
            class="u-mt-md u-mb-sm"
          />
          Calendrier iCal
        </a>
      </div>
      <div class="u-ml-sm u-mr-sm u-flex-item-auto">
        <a
          class="u-flex u-flex-column u-flex-align-center u-text-center u-mb-sm"
          :href="icsLink"
        >
          <LazyImage
            :src="outlook_calendar"
            height="64"
            width="64"
            class="u-mt-md u-mb-sm"
          />
          Calendrier Outlook
        </a>
      </div>
    </div>
  </div>
</template>
